import React from "react";

const Footer = ({ changeFooter }) => {
  let d = new Date();
  return (
    <div className={`footer`}>
      <div className="copyright">
        <p>
          Copyright © Diseñado &amp; Desarrollado por{" "}
          <a target="_blank" rel="noreferrer" href="https://aslatec.com">
            Aslatec
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;